// eslint-disable-next-line import/prefer-default-export
export const MODE_CONTROL_CAMERA_CONTROL = 'MODE_CONTROL_CAMERA_CONTROL';
